import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useKidStore } from '../model/store'

/**
 * `DELETE /admin-api/kids/{kid}` — removes the kid with all its disciplines. The backend refuses
 * (422, nothing removed) a kid with finished lessons or an active subscription; its message is shown as is.
 */
export const useKidDeleteApi = async (kidId: number): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const kidStore = useKidStore()

  const url = useAdminRoutes('admin.kid.destroy', { kid_id: kidId })

  kidStore.trackProcessing(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    const { data } = await $axios.delete<ApiResponse>(url)

    if (!data.success) {
      toast.error(data.message)
      return false
    }

    toast.success(data.message)

    return true
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return false
  } finally {
    kidStore.trackProcessing(false)
  }
}
